import React, { useRef, useState } from 'react'
import { 
  Button,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
  Input,
  Text
 } from '@chakra-ui/react'
import { Fragment } from 'react'
import { useDownloadExcel } from 'react-export-table-to-excel'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { v4 as uuid } from "uuid";
import { Auth } from './Auth'


const TableToExcelCustomer = ({ addresses, faceMatch, panDetails, renderXyz, creditScoreData, partyId, kycCategory, conditionForDecentro, orderData, panDetail }) => {
  const [retailDetails, setRetailDetails] = useState({})
  const [gstInfo, setGstInfo] = useState([])
  const [dinInfo, setDinInfo] = useState({})
  const [btnLoading, setBtnLoading] = useState(false)
  const [myErrorDecentro, setmyErrorDecentro] = useState("")
  const [mySuccessDecentro, setMySuccessDecentro] = useState(false)
  const { isOpen, onOpen, onClose } = useDisclosure()

  const [manualCustomerData, setManualCustomerData] = useState({
    fullName: "",
    linkedMobileNumber: "",
  })

   // ### MANUAL CUSTOMER DETIALS HANDLER ###
   const manualCustomer = (e) => {
    setManualCustomerData({...manualCustomerData, [e.target.name]: `${e.target.value}`})
  }

  const tableRef = useRef(null)
  const { id } = useParams()

  const toast = useToast()



  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: kycCategory === "PVT_LTD" ? `Equipp_${orderData?.OrderName}_Pvt_Ltd_Report` : `Equipp_${orderData?.OrderName}_Credit_Report`,
    sheet: `Equipp_${orderData?.OrderName}_Report`
  })

  // Fetch Bank Details
  useEffect(() => {
    let data = JSON.stringify({
      "orderId": `${id}`,
      "partyId": `${partyId}`
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/decentro/get-order-credit-report`,
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
      data: data
    };

    axios.request(config)
      .then((response) => {
        setRetailDetails(response.data)

       
      })
      .catch((error) => {
        console.log(error);
      });
  },[id,partyId,myErrorDecentro,mySuccessDecentro])

  useEffect(() => {
    // GST
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url:  `${process.env.REACT_APP_RALCO_API_URL}/api/decentro/get-order-gst-report?orderId=${id}`,
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
    };
    if(kycCategory === "PVT_LTD" || kycCategory === "PARTNERSHIP_FIRM"){
      axios.request(config)
      .then((response) => {
        setGstInfo(response.data)
   
      })
      .catch((error) => {
        console.log(error);
      });
    }

   
    
  },[id,kycCategory,myErrorDecentro])


  useEffect(() => {
     // DIN
     let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url:   `${process.env.REACT_APP_RALCO_API_URL}/api/decentro/get-order-din-report?orderId=${id}`,
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
    };
    if(kycCategory === "PVT_LTD"){
    axios.request(config)
    .then((response) => {
      setDinInfo(response.data)
    })
    .catch((error) => {
      console.log(error);
    });
  }
  },[id,kycCategory,myErrorDecentro])



  const creditHandler = () => {

    setBtnLoading(true)
    const ref_id = uuid()

    let data = JSON.stringify({
      "reference_id": `${ref_id}`,
      "consent": true,
      "consent_purpose": "For bank account purpose only",
      "name": `${panDetail?.panDetail?.fullName ||  manualCustomerData?.fullName}`,
      "mobile": `${panDetail?.panDetail?.linkedMobileNumber ||  manualCustomerData?.linkedMobileNumber}`,
      "inquiry_purpose": "PL",
      "partyId": `${orderData.customerPartyId}`,
      "verificationId": `${orderData.id}`
    });
    
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/decentro/credit-report`,
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
      data : data
    };
    
    axios.request(config)
    .then((response) => {
      if((response.data.comment === "Consumer not found in bureau") ){
        setBtnLoading(false)
          setmyErrorDecentro(`${response?.data?.comment} for number - ${panDetail?.panDetail?.linkedMobileNumber || manualCustomerData?.linkedMobileNumber}`)
          toast({
            title: `${response?.data?.comment} for number - ${panDetail?.panDetail?.linkedMobileNumber || manualCustomerData?.linkedMobileNumber}`,
            status: 'error',
            duration: 4000,
            isClosable: true,
            position: 'top'
          })
      }else if(response.data?.responseKey === "error_invalid_mobile"){
        setmyErrorDecentro(`Provided Mobile Number is Invalid`)
        setBtnLoading(false)
        toast({
          title: `Provide Mobile Number is Invalid`,
          status: 'error',
          duration: 4000,
          isClosable: true,
          position: 'top'
        })
      }else if(response?.data?.creditReport?.message === "Credit Report fetched successfully"){
        // setShowCreditData(true)
        renderXyz()
        setmyErrorDecentro('')
        setMySuccessDecentro(true)

 
        toast({
          title: `Credit Report fetched successfully`,
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top'
        })
        setBtnLoading(false)
      }else if(response?.data?.status === "FAILURE"){
        setmyErrorDecentro(`${response?.data?.message}  [${response?.data?.responseKey}]`)
        toast({
          title: `${response?.data?.message} -- ${response?.data?.responseKey}`,
          status: 'error',
          duration: 4000,
          isClosable: true,
          position: 'top'
        })
        setBtnLoading(false)
      }else {
        toast({
          title: 'Oops we are facing some temporary issue with your request',
          status: 'error',
          duration: 4000,
          isClosable: true,
          position: 'top'
        })
        setBtnLoading(false)
      }

    })
    .catch((error) => {
      toast({
        title: `Something went wrong please try again`,
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top'
      })
      setmyErrorDecentro('Something went wrong please try again')
      setBtnLoading(false)
      console.log(error);
    });    
  }

// Condition based download
useEffect(() => {
  if(myErrorDecentro.length > 0 || (mySuccessDecentro === true && Object.keys(retailDetails).length > 0 && addresses.length > 0)) {
    setMySuccessDecentro(false)
    setmyErrorDecentro([])
    onDownload()
  }
},[myErrorDecentro,onDownload, mySuccessDecentro,retailDetails, addresses])

  return (
    <div>
  
      <Button
        onClick={() => {
          if(conditionForDecentro && kycCategory !== "PVT_LTD"){
          {panDetail?.panDetail?.linkedMobileNumber ?  creditHandler() : onOpen()}
          }else {
            onDownload()
          }
        }}
        colorScheme={'yellow'}
        size={'sm'}
        mr={4}
        isLoading={btnLoading}
      >
        {kycCategory === "PVT_LTD" ? 'Download Excel Report' : 'Export Decentro Excel'}
      </Button>
      <div style={{ display: 'none' }}>
        <table ref={tableRef}>
        {Object.keys(retailDetails).length > 0 &&

          <tbody>
          { kycCategory !== "PVT_LTD" &&
            <>
            <tr>
              <th>Key</th>
              <th>Value</th>
            </tr>
            {/* Pan Details */}
            <tr>
              <td>
                <p style={{ fontWeight: '600' }}>PAN variable</p>
              </td>
              <td>
                <p style={{ fontWeight: '600' }}>Response</p>
              </td>
            </tr>
            <tr>
              <td>KYC Status</td>
              <td>
                <span>{panDetails?.statusId}</span>
                <br />
              </td>
            </tr>
            <tr>
              <td>Name</td>
              <td>
                <span>{panDetails?.panDetail?.fullName}</span>
                <br />
              </td>
            </tr>
            {/* Pan end --- */}
            <tr>
              <td>{null}</td>
            </tr>
            <tr>
              <td>{null}</td>
            </tr>
            {/* facematch */}
           
                  <tr>
                    <td>
                      <p style={{ fontWeight: '600' }}>FaceMatch variable</p>
                    </td>
                    <td>
                      <p style={{ fontWeight: '600' }}>Response</p>
                    </td>
                  </tr>
                  <tr>
                    <td>Status</td>
                    <td>
                      <span>{faceMatch?.decentroStatus === "VERIFIED" ? "SUCCESS" : faceMatch?.decentroStatus}</span>
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>Match %</td>
                    <td>
                      <span>{faceMatch?.score}</span>
                      <br />
                    </td>
                  </tr>
               
            <tr>
              <td>{null}</td>
            </tr>
            <tr>
              <td>{null}</td>
            </tr>
            {/* Credit report variables  */}
            <tr>
              <td>
                <p style={{ fontWeight: '600' }}>Credit report variable</p>
              </td>
              <td>
                <p style={{ fontWeight: '600' }}>Response</p>
              </td>
            </tr>
            <tr>
              <td>Full Name</td>
              <td>
                <span>{retailDetails?.bankAccount[0]?.fullName || "n/a"}</span>
                <br />
              </td>
            </tr>
            <tr>
              <td>Age</td>
              <td>
                <span>{retailDetails?.bankAccount[0]?.age || "n/a"}</span>
                <br />
              </td>
            </tr>
            {/* <tr>
                    <td>Total Income</td>
                    <td>
                      <span>n/a</span>
                      <br />
                    </td>
                  </tr> */}
            <tr>
              <td>Score Details - Value</td>
              <td>
                <span>{retailDetails?.creditReport[0]?.creditScore || "n/a"}</span>
                <br />
              </td>
            </tr>
            {/* Pan end --- */}
            <tr>
              <td>{null}</td>
            </tr>
            <tr>
              <td>{null}</td>
            </tr>
            {/* addresss */}
            <tr>
              <td>
                <p style={{ fontWeight: '600' }}>Address Info</p>
              </td>
              <td>
                <p style={{ fontWeight: '600' }}>Details</p>
              </td>
            </tr>
            {myErrorDecentro.length > 0 ? <tr><td>{myErrorDecentro}</td></tr> :
            addresses.map((address, i) => {
              return (
                <Fragment key={i}>
                  <tr key={i}>
                    <td>{`Address Info ${i + 1}`}</td>
                    <td>
                      <span>Reported Date:{address?.reportedDate || 'N/A , data not getting form from Decentro'}</span>
                      <br />
                      <span>Address: {address?.addressline1 || 'N/A , data not getting form from Decentro'}</span>
                      <br />
                      <span>Address Type: {address?.decentroAddressType || 'N/A , data not getting form from Decentro'}</span>
                      <br />
                      <span>State: {address?.state || 'N/A , data not getting form from Decentro'}</span>
                      <br />
                      <span>Postal Code: {address?.pincode || 'N/A , data not getting form from Decentro'}</span>
                    </td>
                  </tr>
                </Fragment>
              )
            })}
            <tr>
              <td>{null}</td>
            </tr>
            <tr>
              <td>{null}</td>
            </tr>
            {/* Rental Account / Bank Account */}
            <tr>
              <td>
                <p style={{ fontWeight: '600' }}>Rental Account Info</p>
              </td>
              <td>
                <p style={{ fontWeight: '600' }}>Details</p>
              </td>
            </tr>
            {myErrorDecentro.length > 0 ? <tr><td>{myErrorDecentro}</td></tr> :
            retailDetails?.bankAccount?.map((bank, i) => {
              return (
                <Fragment key={i}>
                  <tr >
                    <td>{`Rental Account Info ${i+1}`}</td>
                    <td>
                      <span>Institution: {bank?.institution}</span>
                      <br />
                      <span>Account Type: {bank?.decentroAccountType}</span>
                      <br />
                      <span>Credit Limit: {bank?.creditLimit || 'N/A , data not getting form from Decentro'}</span>
                      <br />
                      {/* <span>Sanction Amount: {bank?.sanctionAmount || 'N/A , data not getting form from Decentro'}</span>
                      <br /> */}
                      <span>Date Opened: {bank?.dateOpened}</span>
                    </td>
                  </tr>
                  <tr >
                  <td>{`Acount ${i+1} - 48 month history`}</td>
                  {retailDetails?.bankAccountHistory?.filter((x) => x?.bankAccountId === bank?.id).map((ba, index) => {
                    return (
                    <td key={index}>
                      <span>key: {ba?.key}</span>
                      <br />
                      <span>Payment Status: {ba?.paymentStatus}</span>
                      
                    </td>
                    )
                  })}
                 
                  </tr>
                </Fragment>
              )
            })}

            <tr>
              <td>{null}</td>
            </tr>
            <tr>
              <td>{null}</td>
            </tr>
            </>
        }

            {/* GST -------------------*/}
           {(kycCategory === "PVT_LTD" || kycCategory === "PARTNERSHIP_FIRM") &&
           <>
           
            <tr>
              <td>{null}</td>
            </tr>
            <tr>
              <td>{null}</td>
            </tr>
            {/* GST */}
            <tr>
              <td>
                <p style={{ fontWeight: '600' }}>GST INFO</p>
              </td>
              <td>
                <p style={{ fontWeight: '600' }}>{null}</p>
              </td>
            </tr>
            {gstInfo.length > 0 &&
            <>
            <tr>
              <td>KYC Status</td>
              <td>
                <span>{gstInfo[0]?.kycStatus || 'n/a'}</span>
                <br />
              </td>
            </tr>
            <tr>
              <td>Address</td>
              <td>
                <span>{gstInfo[0]?.address || 'n/a'}</span>
                <br />
              </td>
            </tr>
            <tr>
              <td>Nature of business at address</td>
              <td>
                <span>{gstInfo[0]?.natureOfBusinessAtAddress || 'n/a'}</span>
                <br />
              </td>
            </tr>
            <tr>
              <td>Registered date</td>
              <td>
                <span>{gstInfo[0]?.registrationDate || 'n/a'}</span>
                <br />
              </td>
            </tr>
            <tr>
              <td>Trade name</td>
              <td>
                <span>{gstInfo[0]?.tradeName || 'n/a'}</span>
                <br />
              </td>
            </tr>
            <tr>
              <td>GSTIN</td>
              <td>
                <span>{gstInfo[0]?.gstNumber || 'n/a'}</span>
                <br />
              </td>
            </tr>
            <tr>
              <td>Directors</td>
              <td>
                <span>{gstInfo[0]?.directorsList || 'n/a'}</span>
                <br />
              </td>
            </tr>
            <tr>
              <td>Annual aggregate turnover</td>
              <td>
                <span>{gstInfo[0]?.annualAggregateTurnover || 'n/a'}</span>
                <br />
              </td>
            </tr>
            {/* loop */}
            <td>{`Filling Status`}</td>
                  {gstInfo[0]?.GstFiling.map((gstFilling, index) => {
                    return (
                    <td key={index}>
                      <span>Filing Date: {gstFilling?.filingDate || 'n/a'}</span>
                      <br />
                      <span>Filing For Month: {gstFilling?.filingForMonth || 'n/a'}</span>
                      <br />
                      <span>Filing Annual Return: {gstFilling?.filingAnnualReturn || 'n/a'}</span>
                      <br />
                      <span>Filing Status: {gstFilling?.filingStatus || "n/a"}</span>
                      <br />
                      <span>Filing Gst Type: {gstFilling?.filingGstType || "n/a"}</span>
                      
                    </td>
                    )
                  })}
            </>
            }
             
           </>
           }
            <tr>
              <td>{null}</td>
            </tr>
            <tr>
              <td>{null}</td>
            </tr>

              {/* DIN -------------------*/}
           {kycCategory === "PVT_LTD" &&
           <>
              <tr>
              <td>{null}</td>
            </tr>
            <tr>
              <td>{null}</td>
            </tr>
            {/* DIN */}
            <tr>
              <td>
                <p style={{ fontWeight: '600' }}>DIN INFO</p>
              </td>
              <td>
                <p style={{ fontWeight: '600' }}>{null}</p>
              </td>
            </tr>
            {Object.keys(dinInfo).length > 0 &&
            <>
            <tr>
              <td>DIN</td>
              <td>
                <span>{dinInfo?.dinNumber || 'n/a'}</span>
                <br />
              </td>
            </tr>
            <tr>
              <td>Director</td>
              <td>
                <span>{dinInfo?.directorName  || 'n/a'}</span>
                <br />
              </td>
            </tr>
            
            {/* loop */}
            <td>{`Companies`}</td>
                  {dinInfo.companies.map((gstFilling, index) => {
                    return (
                    <td key={index}>
                      <span>{gstFilling || 'n/a'}</span>        
                    </td>
                    )
                  })}
            </>
            }
            <tr>
              <td>{null}</td>
            </tr>
            <tr>
              <td>{null}</td>
            </tr>
            </>
           }
          </tbody>
        }
        </table>
      </div>
         {/* Manual Credit report modal */}
         <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Generate Credit Report Manually</ModalHeader>
            <ModalCloseButton />
            <ModalBody>

              <FormControl mt={4} >
                <FormLabel>Customer Full Name<Text as={'span'} color={'red.500'}>*</Text></FormLabel>
                <Input placeholder='Enter customer full name' name='fullName' onChange={manualCustomer} autoComplete="off" />
              </FormControl>

              <FormControl mt={4}>
                <FormLabel>PAN Linked Mobile Number<Text as={'span'} color={'red.500'}>*</Text></FormLabel>
                <Input placeholder='Enter customer pan linked mobile number' name='linkedMobileNumber' onChange={manualCustomer} autoComplete="off"/>
              </FormControl>

            </ModalBody>

            <ModalFooter>
              <Button colorScheme='red' mr={3} onClick={onClose}>
                Cancle
              </Button>
              <Button colorScheme='blue' onClick={() => {
              onClose()
              creditHandler()
              }}>Generate</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
    </div>
  )
}

export default TableToExcelCustomer
